import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardContent.module.css';

export const SearchResultCardLocation = () => {
  const { formattedLocation, variant } = useSearchResultCardContext();

  if (variant === 'preview') return null;

  return <Copy className={styles.location} as="p" size="m" text={formattedLocation} />;
};
